module.exports = __webpack_public_path__ + "img/2.45fc0c0e.png";